import React, { useEffect } from 'react';
import cn from 'classnames';
import { convertFromRaw, } from 'wix-rich-content-editor-common';
import { markdownToDraft, draftToMarkdown } from 'markdown-draft-js';
import noop from '../../utils/noop';
import ErrorBoundary from '../../ErrorBoundary';
import Textarea from '../../Textarea';
import s from './Fallback.scss';
var FallbackEditor = function (_a) {
    var value = _a.value, className = _a.className, charLimit = _a.charLimit, onReady = _a.onReady, onChange = _a.onChange, placeholder = _a.placeholder;
    var textareaRef = React.createRef();
    useEffect(function () {
        onReady && onReady(null, {
            clearEditor: noop,
            focusEditor: function () {
                var currEl = textareaRef.current;
                if (currEl) {
                    currEl.focus();
                }
            },
            blurEditor: function () {
                var currEl = textareaRef.current;
                if (currEl) {
                    currEl.blur();
                }
            },
            getCurrentSelection: noop,
            setSelection: noop,
            moveFocusToEnd: function () {
                var currEl = textareaRef.current;
                if (currEl) {
                    currEl.selectionStart = currEl.selectionEnd = currEl.value.length;
                }
            },
            resolveEditorStateForAndroid: function () { return Promise.resolve(); },
        });
    });
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Textarea, { autoSize: true, placeholder: placeholder, defaultValue: value && draftToMarkdown(value, {
                remarkableOptions: {
                    disable: [
                        'blockquote',
                        'code',
                        'fences',
                        'footnote',
                        'hr',
                        'htmlblock',
                        'table',
                        'autolink',
                        'backticks',
                        'del',
                        'entity',
                        'footnote_ref',
                        'htmltag',
                    ]
                }
            }), onChange: function (val) {
                var rawData = markdownToDraft(val);
                onChange && onChange({
                    rawContentState: rawData,
                    editorContent: convertFromRaw(rawData),
                    features: [],
                    isEmpty: val.trim().length === 0
                });
            }, maxLength: charLimit, wrapperClassName: s['wrapper'], textareaClassName: cn(className, s['textarea']), skin: { bar: s['bar'] } })));
};
FallbackEditor.displayName = 'FallbackEditor';
export default FallbackEditor;
//# sourceMappingURL=Fallback.js.map